export const DEAL_NAME_COLUMN = "Basic Info";
export const DEAL_NAME = "Project Name";
export const DEAL_ID = "Project ID";
export const DEAL_AVATAR = "Project Avatar";
export const IS_PARTIALLY_ACCESSIBLE = "is_partially_accessible";
